// Add newlines to biography because Strapi Rich Text does not register them.
const addLineBreak = (text) => {
  if (text) {
    return text.replace(/\n/gi, "\n");
  }
}

export default addLineBreak;